import { connect } from "react-redux"

import {
    clusterSetEditMode,
    clusterModerate
} from "../../../../actions/cluster-actions"
import ClusterViewFormActionButtonsWidget from "./ClusterViewFormActionButtonsWidget"

const mapStateToProps = ({ presentation, authentication }) => ({
    canEdit: authentication.permissions.indexOf("w_cluster") !== -1,
    canDelete: authentication.permissions.indexOf("w_cluster") !== -1,
    showDelete: false,
    activeId: presentation.clusters.activeId,
    isDeleting: presentation.clusters.isDeletingItem,
    moderationStatus:
        presentation.clusters.workingModel.status &&
        presentation.clusters.workingModel.status === "Active",
    isSaving: presentation.clusters.isSavingItem
})

const mapDispatchToProps = dispatch => ({
    onEdit: () => dispatch(clusterSetEditMode(true)),
    reject: () => dispatch(clusterModerate("Archived")),
    approve: () => dispatch(clusterModerate("Active")),
    unmoderate: () => null
})

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ClusterViewFormActionButtonsWidget)
